export const header = {
  wrapper: 'relative h-[20vh]',
  background: {
    glass: 'absolute inset-0',
    mesh: {
      wrapper: 'absolute inset-0',
      container: 'relative w-full h-full',
      dot: 'absolute w-1 h-1 rounded-full'
    }
  },
  content: {
    wrapper: 'relative container mx-auto px-4 h-full flex items-center justify-center',
    container: 'text-center space-y-8 max-w-4xl',
    title: {
      wrapper: 'text-7xl font-bold tracking-tight',
      text: 'inline-block text-transparent bg-clip-text'
    },
    divider: 'h-0.5 mx-auto my-4',
    subtitle: 'text-3xl font-light'
  }
} 